import script from "./headerView.vue?vue&type=script&setup=true&lang=js"
export * from "./headerView.vue?vue&type=script&setup=true&lang=js"

import "./headerView.vue?vue&type=style&index=0&id=89bff404&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89bff404"]])

export default __exports__